import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';

import { logEvent, Event } from '../../../lib/analytics';
import { IconMaximize, IconMinimize } from '../../IconSet';


const messages = defineMessages({
  enterFullScreen: { id: 'enterFullScreenButton' },
  exitFullScreen: { id: 'exitFullScreenMobile' },
});


function MobileFullScreen(_props: {}) {
  const { formatMessage } = useIntl();
  const doc = window.document;
  const docEl = doc.documentElement;

  /*
   * Tested and working on Chrome Mobile, Firefox Mobile and Edge Mobile
   */
  const toggleFullScreen = () => {
    const requestFullScreen = docEl.requestFullscreen;
    const cancelFullScreen = doc.exitFullscreen;

    if (!doc.fullscreenElement) {
      requestFullScreen.call(docEl);
      logEvent(Event.MOBILE_FULLSCREEN, { 'action': 'enter_fullscreen' });
    }
    else {
      cancelFullScreen.call(doc);
      logEvent(Event.MOBILE_FULLSCREEN, { 'action': 'exit_fullscreen' });
    }
  };

  const getIcon = () => {
    const size = 32;
    return doc.fullscreenElement 
      ? <IconMinimize size={size} /> 
      : <IconMaximize size={size} />;
  };

  const itemText = doc.fullscreenElement
    ? messages.exitFullScreen
    : messages.enterFullScreen;

  return (
    <React.Fragment>
      <MenuItem onClick={toggleFullScreen}>
        <ListItemIcon>
          {getIcon()}
        </ListItemIcon>
        <ListItemText primary={formatMessage(itemText)} />
      </MenuItem>
    </React.Fragment>
  );
}


export default MobileFullScreen;
